import React ,{useState} from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';
import PasswordResetForm from 'components/containers/password/PasswordResetForm';
import {Layout, HeaderLayout, BodyLayout} from './style';
export default function PasswordResetLayout() {
	const [isValid, setIsValid] = useState(false);
	const [onSubmit, setOnSubmit] = useState(null);
	return (
		<Layout>
			<HeaderLayout>
				<TitleHeader showComplete={true} isComplete={isValid} onCompleteClick={onSubmit} prevURL={"/"} title={"비밀번호 재설정"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/>
			</HeaderLayout>
			<BodyLayout>
				<PasswordResetForm 
					isValid={isValid}
					setIsValid={setIsValid}
					setOnSubmit={setOnSubmit}
				/>
			</BodyLayout>
		</Layout>)
}